module.exports = __webpack_public_path__ + "static/media/ShortArrowDown.00810b64.svg";